import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const messagingGroupsAdapter = getAdapter();

const messagingGroupsSlice = createSlice({
  name: 'messagingGroups',
  initialState: messagingGroupsAdapter.getInitialState(),
  reducers: {
    setMessagingGroups: (state, { payload: { messagingGroups } }) => {
      messagingGroupsAdapter.setAll(state, messagingGroups);
    },
  },
});

const selectors = messagingGroupsAdapter.getSelectors(({ messagingGroups }) => messagingGroups);

export const getMessagingGroups = (state) => selectors.selectAll(state);

export const { setMessagingGroups } = messagingGroupsSlice.actions;

export default messagingGroupsSlice.reducer;
